import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const registerMobiliserStage = api(async function registerMobiliserStage(id) {
    return query(
        gql`
            query RegisterMobiliserStage($id: String!) {
                registerMobiliserStage(id: $id)
            }
        `,
        { id },
        { returns: "registerMobiliserStage" }
    )
})
